import { memo } from 'react';
import { IndexListItem } from 'components/styles_components/list';
import NotificationItem from 'components/notification/notification_item';

const ListItem = ({ notification }) => (
  <IndexListItem disablePadding>
    <NotificationItem notification={notification} />
  </IndexListItem>
);

export default memo(ListItem);
